<div class="login-failed-container">
  <div class="message-box">
      <h3>{{ 'AUTH.B2C.LOGIN_FAILED' | translate }}</h3>
      <small *ngIf="message">{{ message }}</small>
      <button class="btn btn-primary btn-sm" (click)="retry()">{{ 'AUTH.B2C.RETRY' | translate }}</button>
  </div>
</div>